/**
 * Async boundary.
 *
 * Module Federation negotiates shared dependency versions before any shared
 * module is used. A static import of React here would evaluate it too early, so
 * the real entry point is loaded dynamically. Keep this file exactly this size.
 */
export {};

import("./bootstrap");
